export default {
    indexUserDownloads:     { method: 'get',    url: 'user_downloads' },
    destroyUserDownload:    { method: 'delete', url: 'user_downloads/{id}'},
    indexReports:           { method: 'get',    url: 'reports' },
}